<template>
  <span>
    <a class="subheading mx-3 fake-link" @click.stop="dialog = true">
      About
    </a>
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
          <v-card-title class="headline">What's this?</v-card-title>

          <svg height="20" width="170" class="ml-4">
            <line x1="10" y1="10" x2="15" y2="10" class="line Bakerloo" />
            <line x1="25" y1="10" x2="30" y2="10" class="line Central" />
            <line x1="40" y1="10" x2="45" y2="10" class="line Circle" />
            <line x1="55" y1="10" x2="60" y2="10" class="line District" />
            <line
              x1="70"
              y1="10"
              x2="75"
              y2="10"
              class="line HammersmithCity"
            />
            <line x1="85" y1="10" x2="90" y2="10" class="line Jubilee" />
            <line x1="100" y1="10" x2="105" y2="10" class="line Metropolitan" />
            <line x1="115" y1="10" x2="120" y2="10" class="line Northern" />
            <line x1="130" y1="10" x2="135" y2="10" class="line Piccadilly" />
            <line x1="145" y1="10" x2="150" y2="10" class="line Victoria" />
            <line x1="160" y1="10" x2="165" y2="10" class="line WaterlooCity" />
          </svg>
          <v-card-text>
            Using TfL's carriage load data, the expected crowding for your
            journey is calculated for the next two hours.
          </v-card-text>
          <v-card-text>
            This way, if your plans are flexible, you can figure out when is
            most convenient to travel.
          </v-card-text>
          <v-card-text>
            It could also be a good way to show your employer how flexible
            working hours can help reduce congestion on the tube.
          </v-card-text>
          <v-card-text>
            Lastly, it's worth pointing out that the load data is pre-Covid-19.
            But hopefully it can at least provide a guide.
          </v-card-text>
          <v-card-title class="headline">Contact & Ideas</v-card-title>
          <v-card-text>
            If you'd like to know more or have an idea, please get in touch with
            either
            <a href="https://twitter.com/ithanium" target="_blank">Gabriel</a>
            or
            <a href="https://twitter.com/oscarschafer28" target="_blank"
              >Oscar</a
            >.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">
              Close
            </v-btn>

            <!-- <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                        >
                            Agree
                        </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </span>
</template>
<script>
export default {
  name: "AboutModal",
  data() {
    return {
      dialog: false
    };
  }
};
</script>
<style scoped>
.fake-link {
  text-decoration: underline;
}
a {
  text-decoration: none;
}
.line {
  stroke-width: 5;
  stroke-linecap: round;
}
/* */
.Bakerloo {
  stroke: rgb(178, 99, 0);
}
.Central {
  stroke: rgb(220, 36, 31);
}
.Circle {
  stroke: rgb(255, 211, 41);
}
.District {
  stroke: rgb(0, 125, 50);
}
.HammersmithCity {
  stroke: rgb(244, 169, 190);
}
.Jubilee {
  stroke: rgb(161, 165, 167);
}
.Metropolitan {
  stroke: rgb(155, 0, 88);
}
.Northern {
  stroke: rgb(0, 0, 0);
}
.Piccadilly {
  stroke: rgb(0, 25, 168);
}
.Victoria {
  stroke: rgb(0, 152, 216);
}
.WaterlooCity {
  stroke: rgb(147, 206, 186);
}
.Primary {
  stroke: rgb(25, 117, 210);
}
</style>
